module.exports = __webpack_public_path__ + "80632d8d837004d74291cd7724b17a03.png";